import {
  Box,
  Button,
  Modal,
  ModalContent,
  Typography
} from "@dealer-center/core-components";

// Exported so specs assert the real copy instead of a duplicate that drifts.
export const CONFIRM_DELETE_TITLE = "Confirm Delete";
export const CONFIRM_DELETE_MESSAGE =
  "Are you sure you want to delete this NRT record? This action cannot be undone.";

export interface DeleteConfirmationModalProps {
  isProcessing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationModal = ({
  isProcessing,
  onCancel,
  onConfirm
}: DeleteConfirmationModalProps) => (
  <Modal
    show
    header={CONFIRM_DELETE_TITLE}
    size="small"
    onHide={isProcessing ? undefined : onCancel}
  >
    <ModalContent>
      <Typography variant="body-md">{CONFIRM_DELETE_MESSAGE}</Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
          marginTop: 3
        }}
      >
        <Button
          analyticsConfiguration={{
            eventName: "nrt_mapping_tool_cancel_delete"
          }}
          buttonStyle="secondary"
          disabled={isProcessing}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          analyticsConfiguration={{
            eventName: "nrt_mapping_tool_confirm_delete"
          }}
          buttonStyle="primary"
          disabled={isProcessing}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </Box>
    </ModalContent>
  </Modal>
);
